<template>
    <div class="flex items-center gap-2">
        <a
            href="javascript:void(0)"
            @click="$emit('download', attachment)"
            class="flex items-center space-x-3 p-3 rounded-xl transition-all shadow-sm border flex-1 min-w-0"
            :class="isOutgoing ? 'bg-[#323948] hover:bg-[#3D4555] border-gray-700/50 text-white' : 'bg-gray-50 hover:bg-gray-100 border-gray-200 text-gray-900'"
        >
            <div :class="isOutgoing ? 'bg-white/10' : 'bg-blue-100'" class="p-2 rounded-lg flex-shrink-0">
                <DocumentTextIcon :class="isOutgoing ? 'text-white' : 'text-blue-500'" class="h-6 w-6" />
            </div>
            <div class="flex-1 min-w-0 text-left">
                <div class="text-sm font-semibold truncate">{{ attachment.original_name }}</div>
                <div class="text-[10px] tracking-wider uppercase font-bold" :class="isOutgoing ? 'text-white/50' : 'text-gray-500'">
                    {{ (attachment.size_bytes / 1024 / 1024).toFixed(2) }} MB • {{ (attachment.original_name || '').split('.').pop().toUpperCase() }}
                </div>
            </div>
            <DownloadIcon class="h-5 w-5 flex-shrink-0" :class="isOutgoing ? 'text-white/40' : 'text-gray-400'" />
        </a>

        <button
            type="button"
            v-if="isPdf && !isIos"
            @click="$emit('preview', attachment)"
            class="p-3 rounded-xl border transition-all shadow-sm flex-shrink-0"
            :class="isOutgoing ? 'bg-[#323948] hover:bg-[#3D4555] border-gray-700/50 text-white/70 hover:text-white' : 'bg-gray-50 hover:bg-gray-100 border-gray-200 text-gray-500 hover:text-gray-700'"
            title="Vorschau"
            aria-label="Vorschau"
        >
            <EyeIcon class="h-5 w-5" />
        </button>
    </div>
</template>

<script>
import { DocumentTextIcon, DownloadIcon, EyeIcon } from "@heroicons/vue/outline";

export default {
    name: 'ChatDocument',
    components: { DocumentTextIcon, DownloadIcon, EyeIcon },
    props: {
        attachment: { type: Object, required: true },
        isOutgoing: { type: Boolean, required: true }
    },
    emits: ['download', 'preview'],
    computed: {
        isPdf() {
            return this.attachment.mime_type === 'application/pdf'
                || this.attachment.original_name?.toLowerCase().endsWith('.pdf');
        },
        isIos() {
            return /ipad|iphone|ipod/i.test(navigator.userAgent);
        }
    }
};
</script>
